// La URL base de tu API.
// Si tuvieras un entorno de desarrollo, podrías cambiarla aquí fácilmente.
const API_BASE_URL = "https://app.algoritmojuridico.com/apitributario";
//
//"http://localhost:8083";
//"https://app.algoritmojuridico.com/apitributario";
// Definimos los endpoints específicos para mantener todo organizado.
export const API_ENDPOINTS = {
  // Endpoints de Login/Registro
  login: `${API_BASE_URL}/login`,
  register: `${API_BASE_URL}/register`,
  // Endpoints del Chat
  chat: `${API_BASE_URL}/respuestaia`,
  rateResponse: `${API_BASE_URL}/respuestaval`,
  emailResponse: `${API_BASE_URL}/send-email`,
  // --- AÑADIR ESTA LÍNEA ---
  //createPayment: `${API_BASE_URL}/payments/create-session/`, // O la ruta correcta que defina tu backend
  // Endpoint de Historial (nota el placeholder para el username)
  // Usaremos una función para este caso.
  getChatHistory: (username: string) => `${API_BASE_URL}/get-chats/${username}`,
  getCountChats: (username: string) => `${API_BASE_URL}/count-chats/${username}`,

  forgotPassword: `${API_BASE_URL}/forgot-password`,
  resetPassword: `${API_BASE_URL}/reset-password`,
};